try {
	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	  
	  function getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	const url = new URL(location.href);
	const searchParams = new URLSearchParams(url.search);
	
	//console.info(`TESST: ${searchParams.has("_ref")} && ${searchParams.has("_refv")} && ${getCookie("knipexTracking") != searchParams.get("_refv")}`);
	if(searchParams.has("_ref") && searchParams.get("_ref") == "ca-wtb" && searchParams.has("_refv") && getCookie("knipexTracking") != searchParams.get("_refv")){
	
		console.info("knipexTracking Cookie set!");
		// Cookies.set('knipexTracking', searchParams.get("_refv"), { expires: 7, path: '' })
		setCookie('knipexTracking', searchParams.get("_refv"), 7);
	
	}
} catch (error) {
	console.warn("Knipex Tracking Error:", error);
}